<template>
  <div @click.stop="wxPay">
    <slot></slot>
  </div>
</template>

<script>
  /*
  * :success-pay 支付组件回调（父组件中使用，返回支付结果）
  * */
import wx from 'weixin-js-sdk'
export default {
  data () {
    return {

    }
  },
  props: {
    control: {
      type: Boolean,
      default: () => {
        return true
      }
    },
    params: {
      type: Object,
      default: () => {}
    },
    debug: {
      type: Boolean,
      default: () => false
    },
    payUrl: {
      type: String,
      default: () => ''
    }
  },
  watch: {
    payParams(val, oval) {
      if(val && val !== '') {
        this.$set(this.params, 'Id', val)
        this.wxPay()
      }
    }
  },
  computed: {
    payParams() {
      return this.params.Id
    }
  },
  components: {},
  methods: {
    wxPay() {
      if(this.control) {
        if(this.params.Id) {
          const _this = this
          this.$toast.loading({
            duration: 0,
            mask: true
          });
          this.$post(this.payUrl ? this.payUrl : process.env.VUE_APP_PAY_URL, this.params).then(res => {
            this.$emit('refresh', res)
            if(res) {
              if(res.Status !== 1) {
                this.$toast(res.Message)
                // this.$toast.loading().clear()
                return false
              }
              wx.config({
                debug: _this.debug,
                appId: res.Data.AppId,
                timestamp: res.Data.TimeStamp,
                nonceStr: res.Data.NonceStr,
                signature: res.Data.PaySign,
                jsApiList: [
                  'chooseWXPay'
                ]
              })
              wx.ready(() => {
                wx.chooseWXPay({
                  appId: res.Data.AppId,
                  timestamp: res.Data.TimeStamp,
                  nonceStr: res.Data.NonceStr,
                  package: res.Data.Package,
                  signType: 'MD5',
                  paySign: res.Data.PaySign,
                  success(res) {
                    // if (res.errMsg === 'chooseWXPay:ok') {
                    //   _this.$toast('支付成功')
                    // } else {
                    //   _this.$toast('支付失败')
                    // }
                    _this.$emit('successPay', res.errMsg)
                  },
                  cancel() {
                    _this.$emit('successPay', 'cancel')
                  },
                  error(res) {
                    console.log(res, 'error')
                    _this.$emit('successPay', 'error')
                    // _this.$toast('支付失败')
                  },
                  fail(res) {
                    console.log(res, 'fail')
                    _this.$emit('successPay', 'fail')
                  }
                })
              })
            }
          })
        }
      }
    }
  },
  mounted () {
  }
}
</script>

<style lang="less" scoped>
</style>
